export const links = [
  {
    id: 1,
    link: "https://cdn.freecodecamp.org/testable-projects-fcc/data/tree_map/video-game-sales-data.json",
    name: "videogames",
    description: "Top 100 Most Sold Video Games Grouped by Platform",
  },
  {
    id: 2,
    link: "https://cdn.freecodecamp.org/testable-projects-fcc/data/tree_map/kickstarter-funding-data.json",
    name: "kickstarter",
    description:
      "Top 100 Most Pledged Kickstarter Campaigns Grouped By Category",
  },
  {
    id: 3,
    link: "https://cdn.freecodecamp.org/testable-projects-fcc/data/tree_map/movie-data.json",
    name: "movies",
    description: "Top 100 Highest Grossing Movies Grouped By Genre",
  },
];
